exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tabButtonComponent---1kib8{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;height:45px;width:320px;font-family:poppins;font-size:16px;font-weight:500;border:1px solid #cfd2d4;color:#444;background-color:#fff;outline:none;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;text-decoration:none !important}.tabButtonComponent---1kib8.highlight---IlreC{border:1px solid #959595;background-color:#415667;color:#fff}", ""]);

// exports
exports.locals = {
	"tabButtonComponent": "tabButtonComponent---1kib8",
	"highlight": "highlight---IlreC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/tab-button/index.scss
// module id = 764
// module chunks = 3